import React from "react";

type Props = {
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  rotation?: number;
};

function BrainHalf({ width = 48, height = 98, rotation = 0 }: Props) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 590.87 1188.39"
      width={width}
      height={height}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <defs>
        <style>{`.st0 { fill: none; stroke: #fff; stroke-miterlimit: 10; stroke-width: 5px; }`}</style>
      </defs>
      <path
        className="st0"
        d="M385.02,766.82v.81s0,.12-.04.15c.04-.33.04-.63.04-.95Z"
      />
      <g>
        <path
          className="st0"
          d="M542.44,33.26h-247c-8.28,0-15.96,4.31-20.27,11.38l-93.97,153.32c-4.64,7.58-4.68,17.05-.15,24.66l72.42,120.87H115.55c-9.04,0-17.31,5.12-21.29,13.25L28.79,489.2l-1.68,3.4c-1.42,2.92-2.23,6.04-2.42,9.15-.03.81-.03,1.61,0,2.42.15,3.92,1.28,7.76,3.37,11.23l70.51,116.95-70.41,114.65c-4.68,7.61-4.68,17.23,0,24.88l166.46,271.4c4.32,7.07,12.01,11.38,20.27,11.38h128.7l52.14,88.74c4.28,7.28,12.08,11.74,20.54,11.74h126.17c13.13,0,23.78-10.65,23.78-23.78V57.04c0-13.13-10.65-23.78-23.78-23.78ZM518.65,440.71l-132.32-220.47c-6.77-11.23-21.37-14.89-32.64-8.13-11.28,6.74-14.93,21.37-8.16,32.61l173.11,288.39v574.46h-88.8l-45.12-76.81,72.75-125.95c6.58-11.38,2.67-25.94-8.71-32.5-11.35-6.58-25.91-2.67-32.46,8.71l-72.86,126.06h-91.16l129.46-228.19.07-.15.12-.18c.43-.81.84-1.61,1.17-2.42.11-.18.15-.33.22-.48.18-.4.33-.84.43-1.28.18-.48.33-.99.44-1.46.14-.51.25-.99.36-1.5.12-.54.18-1.13.25-1.72.07-.55.15-1.13.15-1.72,0-.04.04-.07,0-.12,0-.03.04-.06,0-.11.04-.03.04-.11.04-.15v-.81c0-.99-.04-2.01-.19-3v-.03c-.25-2.01-.76-4-1.54-5.86,0-.03,0-.07-.03-.11-.4-.91-.85-1.83-1.36-2.74-.07-.18-.18-.33-.3-.51l-159.06-279.79c-6.52-11.41-21.04-15.44-32.46-8.92-11.41,6.48-15.41,21-8.92,32.42l152.74,268.59-121.56,214.32-135.98-221.74,49.84-81.13,78.34,130.52c4.46,7.47,12.33,11.57,20.42,11.57,4.18,0,8.38-1.1,12.22-3.41,11.28-6.73,14.93-21.36,8.16-32.64l-98.39-163.85-2.37-4-68.91-114.79,54.67-110.65h151.82l88.67,147.72c4.46,7.43,12.32,11.53,20.42,11.53,4.16,0,8.37-1.1,12.22-3.37,11.26-6.77,14.89-21.37,8.16-32.64L235.09,220.24c-.03-.07-.06-.11-.11-.18l-5.71-9.52,79.48-129.72h209.9v359.89Z"
        />
        <polygon
          className="st0"
          points="75.66 501.71 144.57 616.5 75.52 502.01 75.66 501.71"
        />
        <path
          className="st0"
          d="M385.02,766.82v.81s0,.12-.04.15c.04-.33.04-.63.04-.95Z"
        />
      </g>
      <polygon
        className="st0"
        points="144.57 616.5 75.52 502.01 75.66 501.71 144.57 616.5"
      />
      <path
        className="st0"
        d="M24.69,501.75c.18-3.11.99-6.22,2.42-9.15l1.68-3.4c-2.56,3.73-3.95,8.09-4.1,12.55Z"
      />
    </svg>
  );
}

export default BrainHalf;
